import React from 'react';
import GerenciarDiligencias from '@/pages/admin/GerenciarDiligencias';

export const Diligencias: React.FC = () => <GerenciarDiligencias />;

export default Diligencias;
